export default __webpack_public_path__ + "static/media/fruit13.57c21301.jpg";